import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminGuard } from './admin.guard';
import { AttendanceSummaryComponent } from './attendance-summary/attendance-summary.component';
import { AttendanceViewComponent } from './attendance-view/attendance-view.component';
import { ChangeRequestComponent } from './change-request/change-request.component';
import { EmployeeViewReportComponent } from './employee-view/employee-view-report/employee-view-report.component';
import { EmployeeViewRequestComponent } from './employee-view/employee-view-request/employee-view-request.component';
import { EmployeeViewComponent } from './employee-view/employee-view.component';
import { EmployeeComponent } from './employee/employee.component';
import { ReportComponent } from './report/report.component';

const routes: Routes =
[
  {path: 'employee', component: EmployeeComponent, canActivate: [AdminGuard]},
  {path: 'attendance-view', component: AttendanceViewComponent, canActivate: [AdminGuard]},
  {path: 'attendance-summary', component: AttendanceSummaryComponent, canActivate: [AdminGuard]},
  {path: 'report', component: ReportComponent, canActivate: [AdminGuard]},
  {path: 'employee-view', component: EmployeeViewComponent},
  {path: 'employee-view-report', component: EmployeeViewReportComponent},
  {path: 'employee-view-request', component: EmployeeViewRequestComponent},
  {path: 'change-request', component: ChangeRequestComponent, canActivate: [AdminGuard]},
  {path: '**', component: EmployeeViewComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }

